var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1248_1103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.995 7.3958C22.4675 8.09953 21.8297 8.71341 21.1065 9.21372C21.1065 9.39754 21.1065 9.58138 21.1065 9.77543C21.1123 13.1138 19.7787 16.315 17.4049 18.6611C15.0309 21.0072 11.8152 22.3022 8.47867 22.2557C6.54971 22.2621 4.64547 21.8217 2.91509 20.9689C2.82179 20.9281 2.76161 20.8358 2.76195 20.734V20.6216C2.76195 20.475 2.88079 20.3561 3.02738 20.3561C4.92349 20.2935 6.75196 19.6362 8.25408 18.4769C6.53784 18.4423 4.99366 17.4256 4.28302 15.8624C4.24712 15.777 4.2583 15.679 4.3125 15.6039C4.36671 15.5288 4.45612 15.4875 4.54843 15.4947C5.07003 15.5471 5.59685 15.4986 6.10011 15.3517C4.20552 14.9585 2.78194 13.3856 2.57821 11.4606C2.57097 11.3682 2.61235 11.2788 2.68741 11.2245C2.76247 11.1703 2.86036 11.1591 2.94571 11.195C3.45413 11.4194 4.00297 11.5375 4.55864 11.5423C2.89853 10.4527 2.18147 8.38026 2.813 6.49706C2.87818 6.31407 3.0348 6.17888 3.2253 6.14118C3.41578 6.10349 3.61205 6.16883 3.74196 6.31322C5.98218 8.69742 9.06028 10.1182 12.3272 10.2759C12.2436 9.94196 12.2024 9.5988 12.2047 9.25457C12.2353 7.44955 13.3522 5.8416 15.0325 5.18351C16.7128 4.52542 18.6239 4.94742 19.8712 6.25195C20.7215 6.08997 21.5435 5.80439 22.311 5.40427C22.3672 5.36917 22.4386 5.36917 22.4948 5.40427C22.5299 5.46052 22.5299 5.53186 22.4948 5.58811C22.123 6.43946 21.4949 7.15352 20.6981 7.6307C21.3959 7.54978 22.0814 7.38519 22.7398 7.14048C22.7953 7.10274 22.8682 7.10274 22.9236 7.14048C22.97 7.16172 23.0047 7.20236 23.0184 7.25155C23.0323 7.30075 23.0237 7.35351 22.995 7.3958Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1248_1103"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.7893,
    height: 24.5364,
    fill: "white",
    transform: "translate(0.0598145 0.786621)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.a4d9c995fb8ebc0fe2666cf0cd748479.svg";
export { ForwardRef as ReactComponent };